import config from "../config";
import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();
const cache = new Map();

/**
 * Constructs a cache key from payload
 */
const getCacheKey = (payload) => {
  const subact = `${payload.act}_${payload.subact}`;
  return JSON.stringify({ subact, info: payload.info });
};



/**
 * Cached POST request (mainly for master/common APIs)
 */
const postWithCache = async (payload, endpoint = url.COMMON) => {
  const cacheKey = getCacheKey(payload);
  if (cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }
  const response = await api.create(endpoint, payload);
  cache.set(cacheKey, response);
  return response;
};

// Reusable POST methods using api.create
const postLogin = (data) => api.create(url.USER, data);
const fetchFormData = (data) => api.create(url.COMMON, data);

const tickets = (data) => api.create(url.TICKET, data);
const ticketsManagement = (data) => api.create(url.TICKET, data);
const whatsappMessage = (data) => api.create(config.REACT_APP_WHATSAPP_URL, data);
const dashboard = (data) => api.create(url.DASHBOARD, data);
const clients = (data) => api.create(url.CLIENTS, data);

export {
  clients,
  dashboard,
  fetchFormData,
  postLogin,
  whatsappMessage,
  tickets,
  ticketsManagement,
  postWithCache,
};
